import "./Hero.css";
import heroImage from "../../assets/hero-image.jpg";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section id="hero">
      <div className="container grid">
        {/* Descriptions */}
        <article id="hero-description">
          <h1 style={{ color: "#F4CE14" }}>Little Lemon</h1>
          <h2 style={{ color: "#FFFFFF" }}>Chicago</h2>
          <p
            style={{
              color: "#FFFFFF",
              marginTop: "1rem",
              marginBottom: "1.5rem",
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <Link to="/booking" className="button-primary">
            Reserve a Table
          </Link>
        </article>
        {/* Image */}
        <div id="hero-image-wrapper">
          <img src={heroImage} alt="Hero" />
        </div>
      </div>
    </section>
  );
}
